import React from 'react';

import { Grid, GridItem } from 'common/components/Grid';
import { SECTIONS_WITH_BORDERS } from './constants';
import { useFooterLinkSectionAccordion } from './hooks';
import LinkSectionGroup from './LinkSectionGroup';
import Separator from './Separator';
import type { LinkSection } from './utils';

interface FooterLinkSectionContentsProps {
  sections: LinkSection[];
}

const FooterLinkSectionContents = ({ sections }: FooterLinkSectionContentsProps) => {
  const { toggle, isExpanded, isCollapsible } = useFooterLinkSectionAccordion();

  return (
    <>
      <Separator />
      <Grid pt={[null, null, 'sp_12', 'sp_16']} as="nav">
        {sections.map(({ key, data, width }) => (
          <GridItem w={width} key={key}>
            {SECTIONS_WITH_BORDERS.includes(key) && <Separator />}
            <LinkSectionGroup
              data={data}
              sectionName={key}
              isExpanded={isExpanded(key)}
              isCollapsible={isCollapsible}
              onTitleClick={toggle}
            />
          </GridItem>
        ))}
      </Grid>
    </>
  );
};

export default FooterLinkSectionContents;
